import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { startPolling } from './BackgroundPoller.js';

//Start Background Polling
window.addEventListener("load",() => {
    startPolling();
})

// Clear the existing HTML content
document.body.innerHTML = '<div id="app"></div>';

// Render your React component instead
const root = createRoot(document.getElementById('app'));
root.render(<App />);

